/**
 * "Truthy" check for auth routing: an empty object {} is truthy in JS and caused
 * ghost dashboard / undefined navbar names. Require a real identity from the server or login.
 *
 * - Clients: /user/me and login use `clientid` (email may be missing in localStorage until refresh).
 * - We treat non-empty `email` as valid as well.
 */
export function isAuthenticatedUser(u) {
  if (u == null || typeof u !== "object") return false;
  if (Object.keys(u).length === 0) return false;

  const email = String(u.email ?? "").trim();
  if (email) return true;

  const hasClientId =
    u.clientid != null && u.clientid !== "" && u.clientid !== false;
  if (hasClientId) return true;

  return false;
}

/**
 * Kept in sync with AuthContext: normalize flags from legacy data.
 */
export function normalizeUser(u) {
  if (!u) return u;
  if (u.isCoach === undefined && u.isMentor !== undefined) {
    return { ...u, isCoach: !!u.isMentor };
  }
  return u;
}
